import { useState } from 'react';
import { Bell } from 'lucide-react';

const NotificationBell = () => {
    const [hasUnread] = useState(true);

    return (
        <button
            type="button"
            aria-label="Notifications"
            className="relative p-2 rounded-lg text-slate-500 hover:text-slate-900 hover:bg-white border border-transparent hover:border-slate-200 transition"
        >
            <Bell className="w-5 h-5" />
            {hasUnread && (
                <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-rose-500 ring-2 ring-slate-50" />
            )}
        </button>
    );
};

export default NotificationBell;
